(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cart-upsell')) {
    class CartUpsell extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.productContainer = this.querySelector('[data-product-container]');

        this.initData();
      }

      async initData() {
        this.cart = await fetch(`${window.Shopify.routes.root}cart.json`).then(response => response.json());

        if(this.cart.items.length > 0) {
          this.removeAttribute('hidden');
        } else {
          return;
        }

        this.removeAttribute('hidden');
        this.recommendedProduct = await this.getRecommendations(this.cart.items?.[0].product_id);
      }

      async getRecommendations(productId) {
        const recommendations = await fetch(`${window.Shopify.routes.root}recommendations/products.json/?product_id=${productId}&intent=related&limit=1`).then(response => response.json());
        this.buildProductCard(recommendations.products[0]);
      }

      buildOptionSelectors(product, currentVariant) {
        const productOption = [];

        product.options.forEach(option => {
          productOption.push(`<fieldset class="small-card__option-container">
            <legend><span class="sr-only">Select</span> ${option.name}</legend>
            ${option.name.toLowerCase() == 'color' || option.name.toLowerCase() == "colour" ? `
              ${option.values.map(value => {
                return `<label class="small-card__option-label">
                    <input class="small-card__option small-card__option--${option.name.toLowerCase()}"
                      type="radio"
                      name="option-${option.position}-${product.id}"
                      aria-label="${value}"
                      value="${value}"
                      data-option-position="${option.position}"
                      ${value == currentVariant[`option${option.position}`] ? 'checked="true"':''}
                      >
                    <span class="small-card__option-ui">
                      <img src="/cdn/shop/files/${value.replaceAll(' ', '-').replaceAll('/','').replaceAll('--', '-').toLowerCase()}.png?width=25" loading="lazy" alt="Color ${value}" title="${value}">
                    </span>
                  </label>`
              }).join('')}
            ` : `
            ${option.values.map(value => {
              return `<label class="small-card__option-label">
                <input class="small-card__option small-card__option--${option.name.toLowerCase()}"
                  type="radio"
                  name="option-${option.position}-${product.id}"
                  aria-label="${value}"
                  value="${value}"
                  data-option-position="${option.position}"
                  ${value == currentVariant[`option${option.position}`] ? 'checked="true"':''}
                >
                  <span class="small-card__option-ui">
                    ${value}
                  </span>
                </label>`
              }).join('')}
            `}
          </fieldset>`)
        })

        return productOption.join('');
      }

      buildProductCard(product) {
        const currentVariant = product.variants.find(variant => variant.available) || product.variants[0];

        const productCard = `
          <small-card role="group" aria-label="product">
            <div class="small-card__img-container">
              <img
                src="${product.featured_image}&width=70"
                loading="lazy"
                alt=""
                data-small-card-image
                >
            </div>
            <div class="small-card__info">
              <h3 class="small-card__title">${product.title}</h3>
              <div class="small-card__selected-options">
                ${product.options.map(option => {
                  return `
                    <div class="small-card__option">
                      ${option.name}: <span data-option-value="${option.position}" data-option-position="${option.position}">${currentVariant[`option${option.position}`]}</span>
                    </div>
                  `
                }).join('')}
              </div>
              <div class="small-card__price">
                <span class="small-card__compare-at-price" data-compare-price-container ${!product.compare_at_price ? "hidden":""}>
                  <span class="sr-only">Original price:</span>
                  <span data-compare-price>${window.theme.formatMoney(product.compare_at_price, window.theme.moneyFormat)}</span>
                </span>
                <span class="small-card__price">
                  <span class="sr-only">Current Price:</span>
                  <span data-price>${window.theme.formatMoney(product.price, window.theme.moneyFormat)}</span>
                </div>
                <button class="btn small-card__options-toggler" type="button" aria-controls="upsell-options" aria-expanded="false" data-options-toggler>
                  Select Options
                </button>
              </div>

              <div class="small-card__options-container" id="upsell-options" data-card-options hidden>
                <form action="/cart/add">
                  <input type="hidden" name="id" value="${currentVariant.id}"></input>
                  <input type="hidden" name="quantity" value="1"></input>
                  ${this.buildOptionSelectors(product, currentVariant)}

                  <button type="submit" data-add-to-cart class="btn btn--small small-card__atc-button">
                    Add to cart
                  </button>
                </form>
              </div>
            </div>

            <script type="application/json" data-product-json>
              ${JSON.stringify(product)}
            </script>
          </small-card>
        `
        this.productContainer.innerHTML = productCard;

      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('cart-upsell', CartUpsell);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["small-card"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('small-card')) {
    class SmallCard extends HTMLElement {
      constructor() {
        super();
        this.optionsOpen = false;
      }

      connectedCallback() {
        this.abortController = new AbortController();

        const jsonContainer = this.querySelector('[data-product-json]')
        this.productData = JSON.parse(jsonContainer.innerText);
        jsonContainer.remove();

        this.currentVariant = this.productData.variants.find(variant => variant.available);

        this.optionsToggler = this.querySelector('[data-options-toggler]');
        this.optionsContainer = this.querySelector('[data-card-options]');

        this.idInput = this.querySelector('[name="id"]');
        this.comparePriceContainer = this.querySelector('[data-compare-price-container]');
        this.comparePrice = this.querySelector('[data-compare-price]');
        this.price = this.querySelector('[data-price]');
        this.image = this.querySelector('[data-small-card-image]');
        this.addToCartBtn = this.querySelector('[data-add-to-cart]');

        this.addEventListener('change', this.onOptionChange.bind(this), {
          signal: this.abortController.signal
        });

        this.optionsToggler.addEventListener('click', this.toggleOptions.bind(this), {
          signal: this.abortController.signal
        })

        this.optionsContainer.addEventListener('keyup', this.optionsKeyup.bind(this), {
          signal: this.abortController.signal
        })
      }

      onOptionChange() {
        const currentOptions = this.querySelectorAll('.small-card__option:checked');
        const selectedOptions = {
          option1: null,
          option2: null,
          option3: null
        }

        currentOptions.forEach(option => {
          selectedOptions[`option${option.dataset.optionPosition}`] = option.value
        })

        const currentVariant = this.getCurrentVariant(selectedOptions)

        this.updateCardState(currentVariant);
      }

      getCurrentVariant(selectedOptions) {
        const selectedVariant = this.productData.variants.find(variant => {
          return variant.option1 == selectedOptions.option1 &&
          variant.option2 == selectedOptions.option2 &&
          variant.option3 == selectedOptions.option3
        })

        return selectedVariant;
      }

      updateCardState(currentVariant) {
        this.updateOptions(currentVariant);
        this.updatePrice(currentVariant);
        this.updateFeaturedImage(currentVariant);
        this.updateATC(currentVariant);
      }

      updateOptions(currentVariant) {
        currentVariant.options.forEach((option, id) => {
          this.querySelector(`[data-option-value="${id + 1}"]`).innerText = option
        })

        this.idInput.value = currentVariant.id;
      }

      updatePrice(currentVariant) {
        if(currentVariant.compare_at_price) {
          this.comparePriceContainer.removeAttribute('hidden');
          this.comparePrice.innerText = window.theme.formatMoney(currentVariant.compare_at_price, window.theme.moneyFormat);
        } else {
          this.comparePriceContainer.setAttribute('hidden', true);
        }

        this.price.innerText = window.theme.formatMoney(currentVariant.price, window.theme.moneyFormat);
      }

      updateFeaturedImage(currentVariant) {
        this.image.src = currentVariant.featured_image.src + '&width=95'
      }

      updateATC(currentVariant) {
        if(currentVariant.available) {
          this.addToCartBtn.removeAttribute('disabled');
          this.addToCartBtn.innerText = window.theme.strings.add_to_cart;
        } else {
          this.addToCartBtn.setAttribute('disabled', true);
          this.addToCartBtn.innerText = window.theme.strings.sold_out;
        }
      }

      toggleOptions() {
        if(this.optionsOpen) {
          this.closeOptions();
        } else {
          this.openOptions();
        }
      }

      openOptions() {
        this.optionsOpen = true;
        this.optionsToggler.setAttribute('aria-expanded', true);
        this.optionsContainer.removeAttribute('hidden');
        const optionsHeight = this.optionsContainer.scrollHeight;

        setTimeout(() => {
          this.optionsContainer.style.height = optionsHeight + 'px';
        }, 0);
        this.optionsContainer.addEventListener('transitionend', () => {
          this.querySelector('.small-card__option:checked').focus();
        }, {once: true});
      }

      closeOptions(toggleFocus = false) {
        this.optionsOpen = false;
        this.optionsToggler.setAttribute('aria-expanded', false);
        this.optionsContainer.style.height = 0;

        this.optionsContainer.addEventListener('transitionend', () => {
          this.optionsContainer.setAttribute('hidden', true);
        }, {once: true})

        if(toggleFocus) {
          this.optionsToggler.focus();
        }
      }

      optionsKeyup(evt) {
        if(evt.key == 'Escape') {
          evt.preventDefault();
          evt.stopPropagation();
          this.closeOptions(true);
        }
      }

      disconnectedCallback() {
        this.AbortController.abort();
      }
    }
    customElements.define('small-card', SmallCard);
  }
  } catch(e) { console.error(e); }
})();

})();
